import type { ReactNode } from 'react';

export const symbol_type_specimen: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M455-460h170l34 87q2 6 7.38 9.5 5.39 3.5 11.85 3.5 10.77 0 16.77-9t2-19L566-708q-2-5-7.12-8.5T548-720h-15.61q-6.39 0-11.39 3.5-5 3.5-7 8.5L383-388q-4 10 1.92 19 5.93 9 17.08 9 6 0 11.42-3.58 5.41-3.57 7.58-9.42l34-87Zm14-36 69-178h4l69 178H469ZM260-200q-24 0-42-18t-18-42v-560q0-24 18-42t42-18h560q24 0 42 18t18 42v560q0 24-18 42t-42 18H260Zm0-60h560v-560H260v560ZM140-80q-24 0-42-18t-18-42v-590q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v590h590q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q742.75-80 730-80H140Zm120-740v560-560Z"
		/>
	</svg>
);
